import * as React from "react";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import { Route, Redirect, Switch, withRouter, RouteComponentProps } from "react-router-dom";
import { withActionsExecutor, ActionsExecutorPropsType, Action, ActionError } from "components/actions";
import { Grid, Typography } from "components/controls/widget";

import rootPath, { RouteProps } from "./routes-path";

import PageTitle from "common/web/PageTitle";
import PageHeader from "common/web/PageHeader";


import pathHostovaniDlouhodoba from "./hostovani-dlouhodoba/routes-path";
import pathPartneri from "./partneri/routes-path";
import pathPrestupy from "./prestupy/routes-path";

import pathSoutezniUdaje from "./soutezni-udaje/routes-path";
import pathUpajeOp from "./udaje-op/routes-path";
import pathAnketyHlasovani from "./ankety-a-hlasovani/routes-path";
import pathPrispevky from "./prispevky/routes-path";


import HostovaniDlouhodoba from "./hostovani-dlouhodoba/HostovaniDlouhodoba";
import Partneri from "./partneri/Partneri";
import Prestupy from "./prestupy/Prestupy";

import { OsobniUdaje } from "./osobni-udaje/view";
import SoutezniUdaje from "./soutezni-udaje/SoutezniUdaje";
import UpajeOp from "./udaje-op/UpajeOp";
import AnketyHlasovani from "./ankety-a-hlasovani/AnketyHlasovani";
import Prispevky from "./prispevky/Prispevky";

import SideMenu from "./SideMenu";

import Loading from "common/components/controls/Loading";
import Error from "common/components/controls/Error";

import { useMemberDetail } from "./store";

type Props = RouteComponentProps<RouteProps> & WithStyles<typeof styles>;


const styles = (theme: Theme) => createStyles({
    grow: {
        flexGrow: 1,
    },
});


const View = (props: Props) => {

    const { classes, match } = props;
    const { idtClena } = match.params;

    const [{ entity, loading, loadFailure, errors }, { loadMemberData }] = useMemberDetail();

    React.useEffect(() => {
        loadMemberData(Number(idtClena))
    }, []);


    const showDetail = !loading && !loadFailure && entity != null;

    return <div>
        <PageTitle title="Detailní údaje člena" />
        <PageHeader>
            {loading
                ? <Loading loading={loading} color="primary" />
                : loadFailure
                    ? <Error>{errors[""].errors}</Error>
                    : <Typography variant="h5">{`${entity?.prijmeni} ${entity?.jmeno}, IDT ${entity?.idtClena}`}</Typography>
            }
        </PageHeader>

        {showDetail && <Grid container direction="row" justify="flex-end" wrap="nowrap">
            <Grid item className={classes.grow}>
                <Switch>
                    <Route path={rootPath} exact render={() => <OsobniUdaje />} />
                    <Route path={pathHostovaniDlouhodoba} render={() => <HostovaniDlouhodoba clenId={entity.id} />} />
                    <Route path={pathPartneri} render={() => <Partneri clenId={entity.id} />} />
                    <Route path={pathPrestupy} render={() => <Prestupy clenId={entity.id} userAccess={entity.userAccess} />} />
                    <Route path={pathSoutezniUdaje} render={() => <SoutezniUdaje senior={entity.senior} clenId={entity.id} />} />
                    <Route path={pathUpajeOp} render={() => <UpajeOp clenId={entity.id} />} />
                    <Route path={pathAnketyHlasovani} render={() => <AnketyHlasovani />} />
                    <Route path={pathPrispevky} render={() => <Prispevky idtClena={entity.idtClena} />} />
                    <Redirect to={rootPath} />
                </Switch>
            </Grid>
            <Grid item>
                <SideMenu />
            </Grid>
        </Grid>
        }

    </div >
}

const DecoratedView = withRouter(withStyles(styles)(View));

export {
    DecoratedView as DetailClena
}